/* tslint:disable */

/**
 */
export class membershipTmpInput {
    style_search?: string;
    key_input?: string;
}
